import { useEffect } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const REVIEW_SCRIPT = "https://reputationhub.site/reputation/assets/review-widget.js";

/**
 * Renders the client's LeadConnector review widget exactly as provided.
 * The review-widget.js script auto-sizes the iframe — no forced heights,
 * max-heights, or overflow restrictions are applied, so it expands naturally.
 */
const ReviewWidget = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${REVIEW_SCRIPT}"]`)) return;
    const s = document.createElement("script");
    s.src = REVIEW_SCRIPT;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section className="section-padding bg-muted/30">
      <div className="container-max">
        <div className="text-center mb-10">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="eyebrow-pill mb-4"
          >
            <Star className="h-3 w-3 fill-primary" /> Reviews
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl text-foreground mb-4 tracking-tight font-bold"
          >
            What Our <span className="text-gradient-primary">Clients</span> Say
          </motion.h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Real feedback from homeowners and businesses across the Shenandoah Valley.
          </p>
        </div>

        {/* review-widget.js sets the iframe height only after it loads — it
            starts at 0 and jumps to its measured height, shifting everything
            below. The wrapper reserves that height up front (334px at mobile
            widths where the cards stack, 160px once they sit in a row). */}
        <div className="max-w-5xl mx-auto review-widget-reserve">
          <iframe
            className="lc_reviews_widget"
            src="https://reputationhub.site/reputation/widgets/review_widget/yVH34Cdr7FQwvnArb0BM?widgetId=6a4fdb28cca087fdf07b03f1"
            frameBorder="0"
            scrolling="no"
            loading="lazy"
            style={{ minWidth: "100%", width: "100%" }}
            title="Customer reviews"
          />
        </div>
      </div>
    </section>
  );
};

export default ReviewWidget;
